import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
var AppLayout = styled(Box).withConfig({
  componentId: "sc-1pw12wr-0"
})(["position:relative;z-index:0;height:100%;max-height:100%;max-height:-webkit-fill-available;width:100%;display:grid;grid-template-columns:auto minmax(0,1fr);grid-template-rows:auto auto minmax(0,1fr);grid-template-areas:'banner banner' 'header header' 'sidebar main';"]);
var Banner = styled(Box).withConfig({
  componentId: "sc-1pw12wr-1"
})(["grid-area:banner;"]);
var Header = styled(Box).attrs({
  as: "header"
}).withConfig({
  componentId: "sc-1pw12wr-2"
})(["grid-area:header;"]);
var Sidebar = styled(Box).attrs({
  as: "aside"
}).withConfig({
  componentId: "sc-1pw12wr-3"
})(["grid-area:sidebar;"]);
var Main = styled(Box).attrs({
  as: "main"
}).withConfig({
  componentId: "sc-1pw12wr-4"
})(["grid-area:main;overflow:hidden;display:flex;& > *{flex-grow:1;}"]);
export { AppLayout, Banner, Header, Main, Sidebar };